import React from 'react';

function Contact() {
    return (
        <div className="container">
            <div className="card mt-4">
                <div className="card-body">
                    <h2>Contact Us</h2>
                </div>
            </div>
        </div>
    );
}

export default Contact;
